import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
} from 'recharts';
import CustomCard from '../../components/CustomCard';

const DashboardOccupancyChart = ({ occupancyMonthData = [] }) => {
  if (!occupancyMonthData) return <></>;

  const today = new Date();

  const dataWithColor = occupancyMonthData.map((item) => {
    const [year, month] = item.key.split('-').map(Number);
    const itemDate = new Date(year, month - 1);
    const isPast = itemDate < new Date(today.getFullYear(), today.getMonth());
    return {
      ...item,
      fill: isPast ? '#d1d5db' : '#4f46e5',
    };
  });

  return (
    <CustomCard shadow={false} width={12} title="Zajętość">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={dataWithColor}>
          <XAxis dataKey="month" />
          <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} unit="%" />
          <Tooltip
            formatter={(value) => [`${value}%`, 'Zajętość']}
            labelFormatter={(label) => `Miesiąc: ${label}`}
          />
          <Bar dataKey="occupied" name="Zajętość" radius={[10, 10, 0, 0]}>
            {dataWithColor.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </CustomCard>
  );
};

export default DashboardOccupancyChart;
